/**
 * 안전관리비·환경보전비 사용계획 폼 데이터의 숫자 칸을 서버가 읽을 수 있는 값으로 정리한다.
 *
 * 입력 칸은 문자열로 저장되어 "1,000"·""·" 12 " 같은 값이 그대로 전송됐고, .NET 접수 단계가
 * productNum 을 decimal 로 읽지 못해 400 을 냈다(10-02, 안전관리계획서 4건 연속 실패).
 * 규칙: 쉼표·공백·'원'·'₩' 을 떼고 숫자로, 비었거나 숫자가 아니면 null.
 */
export function toNumberOrNull(value: unknown): number | null {
  if (value === null || value === undefined) return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  const cleaned = String(value).replace(/[,\s원₩]/g, "");
  if (cleaned === "") return null;
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : null;
}

const NUMERIC_USAGE_KEYS = ["productNum", "productPrice", "calPrice"] as const;

/** formData(usageStateItems[].usageItems[]) 를 복사해 숫자 칸만 정리한다. 다른 칸은 그대로. */
export function normalizeUsagePlanFormData<T>(formData: T): T {
  if (!formData || typeof formData !== "object") return formData;
  const data: any = formData;
  if (!Array.isArray(data.usageStateItems)) return formData;
  return {
    ...data,
    usageStateItems: data.usageStateItems.map((item: any) => ({
      ...item,
      totalPrice: item && "totalPrice" in item ? toNumberOrNull(item.totalPrice) : item?.totalPrice,
      usageItems: Array.isArray(item?.usageItems)
        ? item.usageItems.map((u: any) => {
            const copy: any = { ...u };
            NUMERIC_USAGE_KEYS.forEach((k) => {
              if (k in copy) copy[k] = toNumberOrNull(copy[k]);
            });
            return copy;
          })
        : item?.usageItems,
    })),
  };
}
